import { Table, Pagination, HeadItemType } from 'components'
import { useState, useEffect, useCallback, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { getOVTracking } from 'services/manage_ov'

import * as S from '../styles'
import { OvTracking } from 'services/manage_ov/interface'
import { Skeleton } from '@mui/material'
import { toast } from 'react-toastify'

const ModalTrackingOV = () => {
  const { ovNumber } = useParams()
  const [loading, setLoading] = useState(true)
  const [trackings, setTrackings] = useState<OvTracking[]>([])

  const [currentPage, setCurrentPage] = useState<number>(1)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [totalItems, setTotalItems] = useState<number>(0)
  const PAGE_SIZE = 10

  const isMounted = useRef(true)

  const headValues: HeadItemType[] = [
    { label: 'Data', columnName: 'Data' },
    { label: 'Hora', columnName: 'Hora' },
    { label: 'Usuário', columnName: 'Usuario' },
    { label: 'Descrição', columnName: 'Descricao' },
    { label: 'Descrição Complementar', columnName: 'DescricaoComplementar' }
  ]

  const renderSkeleton = useCallback(() => {
    const skeleton = []
    for (let i = 0; i < 3; i++) {
      skeleton.push({
        id: `tracking-loading-${i}`,
        content: [
          <Skeleton key={`tracking-skeleton-1-${i}`} width={130} height={30} />,
          <Skeleton key={`tracking-skeleton-2-${i}`} width={80} height={30} />,
          <Skeleton key={`tracking-skeleton-3-${i}`} width={100} height={30} />,
          <Skeleton key={`tracking-skeleton-4-${i}`} width={180} height={30} />,
          <Skeleton key={`tracking-skeleton-5-${i}`} width={300} height={30} />
        ]
      })
    }
    return skeleton
  }, [])

  const renderBody = useCallback(() => {
    if (loading) return renderSkeleton()
    if (!trackings.length) return []

    return trackings.map((tracking, index) => {
      return {
        id: `tracking-item-${index}`,
        content: [
          tracking.DataCriacao ?? '--',
          tracking.HoraCriacao ?? '--',
          tracking.UsuarioCadastro ?? '--',
          tracking.DescricaoOcorrenciaOrdemVenda ?? '--',
          tracking.DescricaoComplementarOrdemVenda ?? '--'
        ]
      }
    })
  }, [loading, trackings, renderSkeleton])

  useEffect(() => {
    isMounted.current = true

    const getTracking = async () => {
      setLoading(true)
      try {
        const response = await getOVTracking(
          { Paginas: currentPage - 1, Linhas: PAGE_SIZE },
          `${ovNumber}`
        )
        if (isMounted.current) {
          const rowsCount = response[0].RowsCount ?? 0
          setTrackings(response)
          setTotalItems(rowsCount)
          setTotalPages(Math.ceil(rowsCount / PAGE_SIZE))
        }
      } catch (error) {
        if (isMounted) toast.error('Erro ao carregar rastreamento')
      } finally {
        if (isMounted.current) setLoading(false)
      }
    }

    if (ovNumber) getTracking()

    return () => {
      isMounted.current = false
    }
  }, [currentPage, ovNumber])

  return (
    <>
      <S.TableWrapper>
        <Table
          headData={headValues}
          bodyData={renderBody()}
          notScrollable
          rowHeight={40}
        />
      </S.TableWrapper>

      {trackings.length > 0 && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          numberOfPages={totalPages}
          numberOfItems={totalItems}
          itemsPerPage={PAGE_SIZE}
          disabled={loading}
        />
      )}
    </>
  )
}

export default ModalTrackingOV
